import * as React from "react"
import {Link} from "gatsby"
import Layout from "../components/layout/layout";

const ContactUsPage = () => {
    return (
        <Layout isHomePage={false} pageName={"Contact Us"}>
        </Layout>
    )
}

export default ContactUsPage
